import AddOnsContainer from "./AddOnsContainer";

export default AddOnsContainer;
